<template>
  <div class="z-layout">
    <router-view />
  </div>
</template>

<script>
  export default {
    components: {
    },
    data() {
      return {
      }
    },
    methods: {
    }
  }
</script>

<style lang="scss" scoped>
  .z-layout {
    display: flex;
    flex-direction: row;
    height: 100vh;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/views/svolt/layout/index.vue